import { useTranslate } from '@tolgee/react';
import { BaseSysMsgProps } from './types';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';
import { SystemMessage } from 'components/Dialogue';
import { memo } from 'react';

export const SysManualMarkSalesStatusMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();

  if (raw?.sysManualMarkSalesStatusContent) {
    const { timestamp, assistantName, salesStatus } = raw.sysManualMarkSalesStatusContent;
    const salesStatusMap: Record<string, string> = {
      BEFORE_SALES_STATUS: t('aide.售前买家'),
      DURING_SALES_STATUS: t('aide.售中买家'),
      AFTER_SALES_STATUS: t('aide.售后买家'),
    };

    return (
      <SystemMessage>
        {t('ViewsChat.修改sales状态', {
          time: dayjs(toNumber(timestamp)).format('MM-DD HH:mm:ss'),
          who: assistantName,
          buyerWho: salesStatusMap[salesStatus],
        })}
      </SystemMessage>
    );
  }

  return null;
});
